import * as React from "react";
import get from "lodash/get";

import "./SVG.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface SVGProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  alt: string;
  fill: string;
  height: string;
  width: string;
  path: string;
}

export class SVG extends ComponentBase<SVGProps> {
  render() {
    const { action, alt, fill, height, width, path } = this.props;
    const style = {
      ...this.props.style,
      cursor: action ? "pointer" : undefined,
    };

    return (
      <div
        id={this.props.configName}
        style={style}
        title={alt}
        className="SVG-svg"
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        aria-label={get(this.props, "label", "")}
        ref={(component) => (this.component = component)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill={fill}
          viewBox={`0 0 ${width} ${height}`}
        >
          <path d={`${path}`} />
        </svg>
      </div>
    );
  }
}
